import { Splide, animationHelpers } from '@hh/global.js'

export class PdpStickyNavigation extends HTMLElement {
  connectedCallback() {
    this.eventsToRemove = []
    this.siteHeader = document.querySelector('[data-header-wrapper]')
    this.parent = document.querySelector(
      `#shopify-section-${this.getAttribute('sectionId')}`
    )
    this.sliderHolder = this.querySelector('[data-pdp-sticky-nav-slider]')
    this.sliderTrack = this.sliderHolder?.querySelector('[data-slider-track]')

    if (this.sliderTrack !== null) {
      this.sliderTrack.innerHTML = ''
    }

    this.targetSectionAnchors = [
      ...document.querySelectorAll('[data-pdp-sticky-navigation]'),
    ]

    this.linksAndAnchors = this.targetSectionAnchors
      .map((anchor) => this.buildSlideLink(anchor))
      .filter(Boolean)

    this.initSlider()
    this.checkOnEvent()

    this.boundCheckOnEvent = this.checkOnEvent.bind(this)
    this.addTrackedEvent(window, 'scroll', this.boundCheckOnEvent)
    this.addTrackedEvent(window, 'resize', this.boundCheckOnEvent)
  }

  disconnectedCallback() {
    this.eventsToRemove.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler)
    })
    this.eventsToRemove = []
    this.slider?.destroy()
  }

  checkOnEvent() {
    this.topCheck()
    this.scrollCheck()
  }

  topCheck() {
    if (!this.parent) { return null }

    if (this.siteHeader !== null) {
      this.parent.style.setProperty(
        '--top-pos',
        `${this.siteHeader.querySelector('.header-v2').offsetHeight}px`
      )
    }

    const productListStickyNav = document.querySelector('[data-product-list-sticky-navigation]')
    if (productListStickyNav !== null) {
      this.parent.style.setProperty(
        '--top-pos-with-product-list-nav',
        `${productListStickyNav.offsetHeight}px`
      )
    }
  }

  scrollCheck() {
    const headerHeight = this.siteHeader?.offsetHeight || 0
    let activeLinkIndex = null
    let minOffset = Infinity

    this.linksAndAnchors.forEach(([section, slideLink], index) => {
      const topOffset = section.getBoundingClientRect().top - headerHeight
      slideLink?.classList.remove('active')

      if (topOffset <= 0 && Math.abs(topOffset) < minOffset) {
        minOffset = Math.abs(topOffset)
        activeLinkIndex = index
      }
    })

    if (activeLinkIndex !== null) {
      const [_, activeSlideLink] = this.linksAndAnchors[activeLinkIndex]
      activeSlideLink?.classList.add('active')
      this.slider?.go(activeLinkIndex)
    }
  }

  buildSlideLink(anchor) {
    const anchorText = anchor?.dataset?.pdpStickyNavigation ?? null
    if (!this.sliderTrack || !anchorText) {
      return null
    }

    const newSlideDiv = document.createElement('div')
    newSlideDiv.classList.add(
      'splide__slide',
      'pdp-sticky-navigation__slide-slide'
    )

    const newSlideLink = document.createElement('a')
    const anchorParentSection = anchor.closest('section')
    newSlideLink.setAttribute('href', `#${anchorParentSection?.id}`)
    newSlideLink.innerHTML = anchorText
    newSlideLink.classList.add('pdp-sticky-navigation__slide-anchor-link')

    newSlideDiv.appendChild(newSlideLink)
    this.sliderTrack.appendChild(newSlideDiv)

    this.addTrackedEvent(newSlideLink, 'click', (event) =>
      this.clickLink(event, anchor)
    )

    return [anchor, newSlideDiv]
  }

  clickLink(event, linkSectionTarget) {
    event.preventDefault()
    if (!linkSectionTarget) {
      return null
    }
    event.preventDefault()

    const currentScrollTop = document.documentElement.scrollTop
    const scrollToPos = animationHelpers.scrollIndexFromPercentage(
      linkSectionTarget,
      1,
      0
    )

    const topPos =
      currentScrollTop < scrollToPos
        ? scrollToPos - this.offsetHeight - 48
        : scrollToPos - this.offsetHeight - this.siteHeader.offsetHeight + 48

    window.scrollTo({
      top: topPos,
      behavior: 'smooth',
    })
  }

  initSlider() {
    if (!this.sliderHolder) {
      return
    }

    this.slider = new Splide(this.sliderHolder, {
      drag: 'free',
      arrows: true,
      pagination: false,
    }).mount()

    const prevButton = this.querySelector('[data-prev-button]')
    const nextButton = this.querySelector('[data-next-button]')
    this.sliderHolder.prepend(prevButton ?? '')
    this.sliderHolder.append(nextButton ?? '')
  }

  addTrackedEvent(element, event, handler) {
    element.addEventListener(event, handler)
    this.eventsToRemove.push({
      element,
      event,
      handler,
    })
  }
}

customElements.define('pdp-sticky-navigation', PdpStickyNavigation)
